import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import debounce from 'lodash/debounce';
import { connect } from 'react-redux';
import { fillDetails } from '../../models/profile';

import Gnb from '../../components/Gnb';
import NotFoundPage from '../NotFoundPage';

import numberFormat from '../../utils/numberFormat';
import { fetchWithJson } from '../../utils/api';
import openWithAppWithoutInstall from '../../utils/openWithAppWithoutInstall';

import RestrictFriendPage from '../RestrictFriendPage';
import AlreadyFriendPage from '../AlreadyFriendPage';
import NotConnectTalkPage from '../NotConnectTalkPage';
import NotAvailableAppkeyPage from '../NotAvailableAppkeyPage';
import MaxLimitFriendPage from '../MaxLimitFriendPage';
import AgeAuthAlertModal from '../../components/AgeAuthAlertModal';

import Cookies from 'universal-cookie';
import * as AdultAuthValidType from "../../constants/AdultAuthValidType";
import { getVerificationBadgeClassName } from '../../utils/profileUtils';
import { getSquircleThumbnailUrl } from "../../utils/imageUtils";

export class AddFriendPage extends Component {
  constructor(props) {
    super(props);
    this.handleOpenWithApp = this.handleOpenWithApp.bind(this);
    this.handleCloseWindow = this.handleCloseWindow.bind(this);
    this.handleAddFriend = this.handleAddFriend.bind(this);
    this.handleGotoAccount = this.handleGotoAccount.bind(this);

    this.renderBridgePage = this.renderBridgePage.bind(this);
    this.isAllowGotoAccountPage = this.isAllowGotoAccountPage.bind(this);
  }

  componentDidMount() {
    const { device, profile } = this.props;
    if (device.getIn(['device', 'type']) === 'mobile' && !this.isAllowGotoAccountPage() && profile) {
      this.handleOpenWithApp();
    } 
  }

  handleOpenWithApp() {
    const { profile, device } = this.props;
    openWithAppWithoutInstall(
      device.getIn(['os', 'name']),
      process.env.REACT_APP_PF_CUSTOM_SCHEME,
      `plusfriend/home/${profile.get('uuid')}/add`,
      'com.kakao.talk'
    );
  }

  handleAddFriend() {
    const { profile } = this.props;

    fetchWithJson(`/api/profiles/${profile.get('profileId')}/add_friend`, { method: 'POST', credentials: 'same-origin' })
    .then((response) => {
      if (response.code == -140000) {
        alert("성인인증 완료 후, 채널 추가를 해주세요.");
      } else {
        location.href = `/${profile.get('profileId')}/add_friend_done`;
      }
    }).catch((response) => {
      console.log(response);
    });
  }

  handleCloseWindow() {
    const { profile } = this.props;
    if (window.opener) {
      if (window.__BROWSER_NAME__ === "Mobile Safari") {
        const open = window.open(',', '_self');
        if (open) {
          open.close();
        } else {
          window.close();
        }
      } else {
         window.close();
      }
    } else {
      location.href = "/" + profile.get('profileId');
    }
  }

  handleGotoAccount() {
    const cookies = new Cookies();
    cookies.set('_rhkap', true, { path: '/' });
    window.location.reload();
  }

  isAllowGotoAccountPage() {
    const { cookie } = this.props;
    const cookies = new Cookies(cookie);
    return cookies.get('_rhkap') === 'true';
  }

  renderBridgePage() {
    const { device, profile } = this.props;

    const MultiElement = () => [
      <div id="kakaoHead" className="head_bridge" role="banner" key="header">
        <h1 className="tit_logo">
          <a href="#none" className="link_logo" style={{ padding: 0 }}>
            <span className="ico_plus ico_logo">카카오톡 채널</span>
          </a>
        </h1>
      </div>,
      <hr className="hide" key="hidden_line" />,
      <div id="kakaoContent" className="cont_bridge" role="main" key="content">
        <span className="img_bridge" />
        <strong className="tit_bridge">채널 추가를 위해<br/>카카오톡을 실행합니다. </strong>
        <p className="desc_bridge">카카오톡이 설치되지 않았거나,<br/>최신 버전이 아닌 경우<br/>카카오계정으로 로그인해 주세요.</p>
        <a href="#none" className="btn_talk btn_type1" onClick={this.handleOpenWithApp}>
          카카오톡 실행하기
        </a>
        <a href="#none" className="btn_talk btn_type2" onClick={this.handleGotoAccount}>
          카카오계정 로그인하기
        </a>
        <div className="logout_bridge">
          <a href={`${process.env.REACT_APP_KAKAO_ACCOUNT_URL}/logout?continue=${process.env.REACT_APP_SERVICE_HOST}/logged_out`}
            className="btn_bridge link_bridge link_type2 #logout"
          >
            로그아웃
          </a>
        </div>
      </div>
    ];
    return (<MultiElement />);
  }

  render() {
    const { device, profile, error, validType } = this.props;
    const addFriendBtnDisplay = validType == undefined || validType == AdultAuthValidType.VERIFIED
        ? 'block' : 'none';
    if (error) {
      if (error.get('message') === "Not Connect Talk") {
        return (
          <NotConnectTalkPage {...this.props} />
        )
      } else if (error.get('message') === "Not Available SDK Appkey") {
        return (
          <NotAvailableAppkeyPage {...this.props} />
        )
      }
    }

    if (!profile) {
      return (
        <div>
          <Gnb device={device} />
          <NotFoundPage {...this.props} />;
        </div>
      )
    }

    const { name, profileImage, statusMessage, friendCount, spamLevel, verificationType, isFriend } = profile;
    if (spamLevel === 5) {
      return ( <RestrictFriendPage profile={profile} device={device} />)
    }

    if (isFriend) {
      return (<AlreadyFriendPage profile={profile} device={device} />)
    }
    if (device.getIn(['device', 'type']) === 'mobile' && !this.isAllowGotoAccountPage()) {
      return this.renderBridgePage(); 
    } 

    const badgeClassName = getVerificationBadgeClassName(verificationType);
    const RenderMultiElement = () => [
      <div id="kakaoHead" className="head_bridge" role="banner" key="header">
        <h1 className="tit_logo">
          <a href="#none" className="link_logo" style={{ padding: 0 }}>
            <span className="ico_plus ico_logo">카카오톡 채널</span>
          </a>
        </h1>
      </div>,
      <hr className="hide" key="hidden_line" />,
      <div id="kakaoContent" className="cont_bridge" role="main" key="content">
        <div className="innner_bridge inner_bridge2">
          <h2 id="kakaoBody" className="screen_out">채널 추가영역</h2>
          <a href="#none" className="link_profile">
              <img src={getSquircleThumbnailUrl(profileImage.get('mediumUrl').replace('http://', 'https://'))} className="img_profile" alt="프로필 사진 보기" style={{height: '100%'}} />
          </a>
          <strong className="tit_profile">{name}
              {
                <span className={badgeClassName}></span>
              }
          </strong>
          {
            friendCount > 0 && <span className="txt_count">친구 <em className="emph_g">{numberFormat(friendCount)}</em>명</span>
          }
          <div>
            <p className="desc_bridge">{name} 채널의<br />정보와 이벤트를 카카오톡으로 받을 수 있습니다.<br />동의하고 채널 추가 하시겠습니까?</p>
            <div className="group_btn">
              <a id="cancel_btn" className="btn_bridge" style={{ cursor: 'pointer' }} onClick={this.handleCloseWindow}>취소</a>
              <a id="add_friend_btn"
                 className="btn_bridge btn_type1"
                 style={{ cursor: 'pointer' }}
                 onClick={this.handleAddFriend}
                style={{ display: addFriendBtnDisplay }}
              >채널 추가</a>
            </div>
          </div>
          <div className="logout_bridge">
            <a href={`${process.env.REACT_APP_KAKAO_ACCOUNT_URL}/logout?continue=${process.env.REACT_APP_SERVICE_HOST}/logged_out`}
              className="link_logout"
            >
              로그아웃
            </a>
          </div>
        </div>
        <AgeAuthAlertModal
          renderCancelBtn={true}
            { ...this.props}
        />
      </div>
    ];
    return (<RenderMultiElement />);
  }
}

const mapStateToProps = (state, { match: { params: { encodedProfileId } } } ) => {
  const { entities, profile, device, error, cookie } = state;
  const profiles = entities.get('profiles', Immutable.Map());
  const selectedProfile = fillDetails(profiles.get(`${encodedProfileId}`), entities);
  const validType = selectedProfile ? selectedProfile.authInfo.get('validType') : '';// 톡에 연결되지 않은 프로필은 데이터가 존재하지 않음.
  return { profile: selectedProfile, device, error, cookie, validType };
};

export default connect(
  mapStateToProps, (dispatch) => bindActionCreators({}, dispatch)
)(AddFriendPage);



// WEBPACK FOOTER //
// ./src/containers/AddFriendPage/index.js